import RequestHandler from "util/RequestHandler";

const PANEL_TYPE_B2B = 1;
const FINIKA_REGISTER_URL = "https://panel.finika.co/register";

export { PANEL_TYPE_B2B, FINIKA_REGISTER_URL };

export const BANNER_SCREEN_POPUP = "AnaSayfa";

export function trackBannerClick({
  bannerId,
  screenName,
  panelType = PANEL_TYPE_B2B,
  firmId = null,
}) {
  RequestHandler.post(
    "/Banner/TrackClick",
    {
      bannerId,
      screenName,
      panelType,
      firmId,
    },
    false,
  );
}

/**
 * @param {object} banner
 * @param {{ isLogin: boolean }} options
 * @returns {string|null|undefined}
 */
export function resolveBannerTargetUrl(banner, { isLogin }) {
  if (isLogin) {
    return banner.b2BRedirectUrl || banner.redirectUrl || FINIKA_REGISTER_URL;
  }

  console.log("BannerClickActions: resolveBannerTargetUrl: banner:", banner);
  return banner.b2BRedirectUrl || banner.redirectUrl || FINIKA_REGISTER_URL;
}

export function openBannerTarget(target) {
  if (target && String(target).length > 0) {
    window.open(target, "_blank", "noopener,noreferrer");
  }
}
